// Number of milliseconds between timer updates
export const TICK_RATE = 300;

// Milliseconds between polling for new messages
export const MESSAGE_POLL_INTERVAL = 1000 * 60 * 2;